import { render, staticRenderFns } from "./CaseScenario.vue?vue&type=template&id=6f962a7c&scoped=true&"
import script from "./CaseScenario.vue?vue&type=script&lang=js&"
export * from "./CaseScenario.vue?vue&type=script&lang=js&"
import style0 from "./CaseScenario.vue?vue&type=style&index=0&id=6f962a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f962a7c",
  null
  
)

export default component.exports